import { AccessControl } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerFundedMarketingHomeAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingInsights,
    ],
    restrictedBannersAllowed: true,
    notFeatureToggles: [FeatureToggle.retailerFundedMarketingUserDenyList],
  },
]

// Nav-only gate: hides the legacy "Campaigns" entry once the marketing-tooling
// rollout takes its slot. Routes stay reachable via the opt-out banner redirect.
// `notFeatureToggles` with a plain array is AND-on-hide (hide iff every listed
// toggle is on), so we wrap in `AccessControl.oneOf` to get OR-on-hide — hide
// iff EITHER the deny-list OR the marketing-tooling rollout toggle is on.
// `AccessControl.oneOf` overloads are typed for the dashboard's FeatureToggle
// enum, not domain-local ones, so we cast through `never` to satisfy overload
// resolution.
export const retailerFundedMarketingHomeNavAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingInsights,
    ],
    restrictedBannersAllowed: true,
    notFeatureToggles: AccessControl.oneOf([
      FeatureToggle.retailerFundedMarketingUserDenyList,
      FeatureToggle.marketingToolingRetailerEnabled,
    ] as never) as never,
    notWarehouseFeatureToggles: [FeatureToggle.marketingToolingRetailerEnabled],
  },
]
